import { render, staticRenderFns } from "./AddNewRequest.vue?vue&type=template&id=c08f942c&scoped=true&"
import script from "./AddNewRequest.vue?vue&type=script&lang=ts&"
export * from "./AddNewRequest.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewRequest.vue?vue&type=style&index=0&id=c08f942c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08f942c",
  null
  
)

export default component.exports